import { render, staticRenderFns } from "./LandingFooter.html?vue&type=template&id=55837bd4&scoped=true&"
import script from "./LandingFooter.ts?vue&type=script&lang=ts&"
export * from "./LandingFooter.ts?vue&type=script&lang=ts&"
import style0 from "./LandingFooter.scss?vue&type=style&index=0&id=55837bd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55837bd4",
  null
  
)

export default component.exports